var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.params.showOverlay)?_c('div',{staticClass:"mar-y--big"},[_c('div',{staticClass:"font-small-heading"},[_vm._v(" "+_vm._s(_vm.params.heading)+" ")]),(_vm.params.showSubline)?_c('div',{staticClass:"font-body-1 mar-top--tiny"},[_vm._v(" "+_vm._s(_vm.params.subline)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }